import { mapDepartments } from '../../models/Department'
import { axiosWithAuth } from '../withAuth'

// opslagsdata/hentafdelinger
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getDepartments = async () => {
    const response = await axiosWithAuth.get(`/opslagsdata/hentafdelinger`)

    return mapDepartments(response.data.Afdelinger)
}

export { getDepartments }
